"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHttpCodeOkOrCreated = isHttpCodeOkOrCreated;
exports.isHappyResponse = isHappyResponse;
function isHttpCodeOkOrCreated(code) {
    return [200, 201].includes(code);
}
function isHappyResponse(response) {
    return response && response.data && isHttpCodeOkOrCreated(response.status);
}
//# sourceMappingURL=common.js.map